module.exports = __webpack_public_path__ + "img/face.071594c6.png";